import { render, staticRenderFns } from "./modal-welcome.vue?vue&type=template&id=297f5d4e"
import script from "./modal-welcome.vue?vue&type=script&lang=js"
export * from "./modal-welcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports